<template>
  <v-card class="pa-1 mb-1 primary darken-2">
    <v-card-title class="text-title">
      {{ showTooltip.items[0].value ? showTooltip.items[0].value : `Código Tecpar ${showTooltip.items[5].value}` }}
    </v-card-title>

    <v-card-text>
      <v-row dense v-for="(item, i) in showTooltip.items" :key="i">
        <v-col cols="6" sm="6" v-if="item.label != 'SIA' && i !=5">
          <span class="text-item">{{ item.label }}</span>
        </v-col>
        <v-col cols="6" sm="6" v-if="item.label != 'SIA' && i !=5">
          <div class="d-flex">
            <v-icon :color="getNameAndColorIce(item.value).color" size="21px">fiber_manual_record</v-icon><strong
              class="text-value pt-0 pl-3">{{
                getNameAndColorIce(item.value).name
              }}</strong>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "TooltipIce",
  props: ["tooltipParams", "showTooltip"],
  data: () => ({}),
  methods: {
    normalizeStr(str) {
      return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    },
    getNameAndColorIce(s) {
      if (s != null || s != "") {
        const status = this.normalizeStr(s);
        if (status.startsWith("boa") || status.startsWith("bom")) {
          return {
            color: '#219653',
            name: 'Bom'
          }
        }
        if (status.startsWith("regular")) {
          return {
            color: '#F2C94C',
            name: 'Regular'
          }
        }
        if (status.startsWith("ruim")) {
          return {
            color: '#F2994A',
            name: 'Ruim'
          }
        }
        if (status.startsWith("pessim")) {
          return {
            color: '#EB5757',
            name: 'Péssimo'
          }
        }
        if (status.startsWith("otim")) {
          return {
            color: '#2F80ED',
            name: 'Ótimo'
          }
        }
      }

      return {
        color: '#D9D9D9',
        name: 'Sem Dados'
      }
    }
  }
};
</script>



<style scoped>
.text-title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #ffffff;
}

.text-subtitle {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #ffffff;
}

.text-item {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #FFFFFF;
  left: 24px;
}

.text-value {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #FFFFFF;
}
</style>